import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

export interface CategoryExplorerItem {
  id: string;
  title: string;
  image: string;
  imageAlt: string;
  href: string;
}

interface CategoryExplorerCardProps {
  item: CategoryExplorerItem;
}

const CategoryExplorerCard: React.FC<CategoryExplorerCardProps> = ({ item }) => {
  return (
    <article className="category-explorer-card group h-full">
      <Link
        to={item.href}
        className="relative block h-full overflow-hidden rounded-2xl motion-card focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900/20 focus-visible:ring-offset-2 motion-safe:hover:-translate-y-0.5"
      >
        <div className="relative aspect-[4/5] w-full overflow-hidden bg-neutral-900 sm:aspect-[3/4]">
          <img
            src={item.image}
            alt={item.imageAlt}
            className="absolute inset-0 h-full w-full object-cover motion-image-zoom motion-safe:group-hover:scale-[1.04]"
            loading="lazy"
            decoding="async"
          />
          <div
            className="image-overlay-card__scrim absolute inset-x-0 bottom-0 h-[52%] bg-gradient-to-t from-black/90 via-black/55 to-transparent"
            aria-hidden
          />
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 px-5 py-5 sm:px-6 sm:py-7">
            <h3 className="image-overlay-card__title text-lg leading-snug tracking-tight sm:text-xl lg:text-[22px]">
              {item.title}
            </h3>
            <span
              className="image-overlay-card__action flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur-[2px] transition-colors duration-300 group-hover:bg-orange-500/75"
              aria-hidden
            >
              <ArrowForwardIcon className="h-[15px] w-[15px]" />
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default CategoryExplorerCard;
